<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<template>
  <div class="container">
    <div class="w-full flex mb-8 xl:mb-12">
      <div class="w-1/2">
        <div class="w-full h-3px bg-secondary mb-3" />
        <div
          class="flex items-center text-xxs leading-none px-4 xl:text-sm"
          :aria-disabled="step !== 1"
        >
          <div class="flex-shrink-0 mr-2">
            <div v-if="step === 2">
              <img src="~images/psp/passed.svg" :alt="$t('components.navigation.stepPassed')" class="w-4.25 h-4.25">
            </div>
            <div
              v-if="step === 1"
              class="w-4.25 h-4.25 rounded-full text-xxs flex items-center justify-center font-bold bg-secondary"
            >
              1
            </div>
          </div>
          <span :class="['font-bold', step === 1 ? '' : '']">{{ $t('components.navigation.step1') }}</span>
        </div>
      </div>
      <div class="w-1/2">
        <div :class="['w-full h-3px mb-3', step === 1 ? 'bg-gray-200' : 'bg-secondary']" />
        <div
          class="flex items-center text-xxs leading-none px-4 xl:text-sm"
          :aria-disabled="step !== 2"
        >
          <div class="flex-shrink-0 mr-2">
            <div
              :class="[
                'w-4.25 h-4.25 rounded-full text-xxs flex items-center justify-center',
                step === 1 ? 'bg-gray-350 text-white' : 'bg-secondary font-bold',
              ]"
            >
              2
            </div>
          </div>
          <span :class="[step === 1 ? 'text-gray-350' : 'font-bold']">{{ $t('components.navigation.step2') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
